import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { MAX_LIMIT } from 'config';

export default getShazamTableData;

interface IProps {
  countryIds?: any;
  download?: boolean;
  entityIds: string;
  limit?: number;
  offset?: number;
  entityType: 'track' | 'artist';
  sortOrder?: string;
  sortBy?: string;
  tagType: 'cities' | 'countries';
  cityIds?: string[];
  countriesLimit?: number;
  countriesOffset?: number;
}

function getShazamTableData(args: IProps): string {
  const {
    countryIds,
    download,
    entityIds,
    limit = MAX_LIMIT,
    offset,
    entityType,
    sortBy,
    sortOrder,
    tagType,
    cityIds,
    countriesLimit,
    countriesOffset,
  } = args;

  const apiEntityType = entityTypeToApiType(entityType);

  const params = stringify({
    countriesLimit,
    countriesOffset,
    countryIds,
    cityIds,
    download,
    limit,
    offset,
    sortBy,
    sortOrder,
  });

  return `/api/discoveries/table/${apiEntityType}/${entityIds}/${tagType}${
    params !== '' ? `?${params}` : ''
  }`;
}
